var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTierAction(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 11.521,
    viewBox: "1046 439.218 16 11.521",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16037"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16036",
    transform: "translate(1046 439.218)",
    clipPath: "url(\"#a\")"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.31.001h4.916c.833.002 1.432.647 1.376 1.477-.045.662-.591 1.182-1.29 1.23a1.908 1.908 0 0 1-.13.003H1.435c-.65 0-1.158-.34-1.357-.904A1.35 1.35 0 0 1 1.351.003C3.004-.003 4.657.001 6.31.001",
    fillRule: "evenodd",
    "data-name": "Path 8814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.309 11.52h-4.93C.672 11.517.09 11.015.015 10.352c-.096-.85.507-1.535 1.363-1.542.69-.005 1.379 0 2.068 0h7.75c.676 0 1.22.406 1.371 1.02a1.35 1.35 0 0 1-1.314 1.688c-1.596.004-3.19.001-4.786.001h-.16",
    fillRule: "evenodd",
    "data-name": "Path 8815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.308 4.403c1.649 0 3.297-.005 4.945.003.553.003.974.264 1.216.762.237.486.188.967-.133 1.404-.272.37-.652.545-1.11.545-1.359.002-2.718 0-4.077 0-1.923 0-3.846.002-5.77 0-.717 0-1.294-.515-1.367-1.212a1.35 1.35 0 0 1 1.351-1.5c1.417-.004 2.834-.002 4.251-.002h.694",
    fillRule: "evenodd",
    "data-name": "Path 8816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.29 1.357c0-.756.602-1.357 1.358-1.355.747.001 1.35.603 1.352 1.35a1.36 1.36 0 0 1-1.361 1.358 1.352 1.352 0 0 1-1.349-1.353",
    fillRule: "evenodd",
    "data-name": "Path 8817"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.29 5.76a1.354 1.354 0 1 1 2.71.008 1.362 1.362 0 0 1-1.353 1.35A1.355 1.355 0 0 1 13.29 5.76",
    fillRule: "evenodd",
    "data-name": "Path 8818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.644 11.52a1.347 1.347 0 0 1-1.354-1.36 1.351 1.351 0 0 1 1.352-1.35c.75 0 1.363.615 1.358 1.363a1.354 1.354 0 0 1-1.356 1.347",
    fillRule: "evenodd",
    "data-name": "Path 8819"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v11.521H0V0z",
    "data-name": "Rectangle 129"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTierAction);
export default __webpack_public_path__ + "static/media/tierAction.33c5bb61a6682e74e59d5cc7b5e8f520.svg";
export { ForwardRef as ReactComponent };